/**
 * Arranque de la PWA.
 *
 * El registro del service worker es MANUAL y con confirmacion (`registerType: 'prompt'`):
 * una actualizacion automatica podria recargar la pagina mientras el cajero tiene un
 * pago a medio capturar. El usuario decide cuando aplicarla.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App.js';
import './styles.css';

const raiz = document.getElementById('raiz');
if (raiz === null) throw new Error('No se encontró el contenedor de la aplicación');

/** Aviso de nueva version. La aplica solo si el usuario acepta. */
const updateServiceWorker = registerSW({
  onNeedRefresh() {
    window.dispatchEvent(new CustomEvent('senm:actualizacion-disponible'));
  },
  onOfflineReady() {
    window.dispatchEvent(new CustomEvent('senm:listo-sin-conexion'));
  },
});

window.addEventListener('senm:aplicar-actualizacion', () => {
  void updateServiceWorker(true);
});

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
